export abstract class UnistocksFeatures {
  public static readonly Prefix = 'Unistocks';
  public static readonly DevTools = this.Prefix + '.DevTools';
  public static readonly SavingsGoals = this.Prefix + '.SavingsGoals';
  public static readonly SharedPortfolios = this.Prefix + '.SharedPortfolios';
}

export abstract class UnistocksExternalFeatures {
  public static readonly Prefix = 'UnifyStocks.External';

  public static readonly ImportGroup = this.Prefix + '.Import';
  public static readonly BankGroup = this.ImportGroup + '.Bank';
  public static readonly CryptoCurrencyGroup = this.ImportGroup + '.CryptoCurrency';

  public static readonly TransactionSync = this.ImportGroup + '.Transations';
}
